import React from "react";
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Receipt, ArrowRight } from "lucide-react";

export function HomeBillAlert({ t }) {
  return (
    <section className="max-w-[1120px] mx-auto px-4 sm:px-6 mt-8">
      <Card className="p-4 sm:p-5 border-[hsl(var(--brand-urgent))]/30 bg-[hsl(var(--brand-urgent))]/5">
        <div className="flex items-start gap-3">
          <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-[hsl(var(--brand-urgent))] text-white shrink-0">
            <Receipt className="h-5 w-5" />
          </span>
          <div className="flex-1">
            <h2 className="text-base sm:text-lg font-semibold text-[hsl(var(--brand-navy))]">{t("home.bill_alert_title")}</h2>
            <p className="text-sm text-[hsl(var(--muted-foreground))] mt-1">{t("home.bill_alert_body")}</p>
          </div>
          <Link to="/contatti" className="hidden sm:inline-flex shrink-0">
            <Button className="h-10 bg-[hsl(var(--brand-urgent))] hover:bg-[hsl(var(--brand-urgent))]/90 text-white">
              {t("common.get_quote")} <ArrowRight className="h-4 w-4 ml-1" />
            </Button>
          </Link>
        </div>
      </Card>
    </section>
  );
}

export default HomeBillAlert;
